// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clip-creator-media-library-modal--vwHaD .modal-body{height:75vh;height:75dvh}.clip-creator-media-library-modal--vwHaD .toggle-select-group .btn.btn-tertiary.active{background-color:#5645f5;color:#fff;outline-color:#5645f5}.clip-creator-media-library-modal--vwHaD .voiceover-asset .show-on-hover{display:none !important}.clip-creator-media-library-modal--vwHaD .voiceover-asset .actions-container{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clip-creator-media-library-modal": "clip-creator-media-library-modal--vwHaD"
};
export default ___CSS_LOADER_EXPORT___;
